import { render, staticRenderFns } from "./LoadPresets.vue?vue&type=template&id=3ee13c40&scoped=true"
import script from "./LoadPresets.vue?vue&type=script&lang=ts"
export * from "./LoadPresets.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee13c40",
  null
  
)

export default component.exports